import { RemoteGetPerformanceReportForProfessionalsSummary } from 'data/usecases';
import { GetPerformanceReportForProfessionalsSummaryUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPerformanceReportForProfessionalsSummary } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetPerformanceReportForProfessionalsSummary =
  (): GetPerformanceReportForProfessionalsSummaryUseCaseInterface =>
    new RemoteGetPerformanceReportForProfessionalsSummary(
      makeApiUrlPerformanceReportForProfessionalsSummary(),
      makeAxiosHttpClient(),
    );
